import { FiCheck } from "react-icons/fi";
import {
  CheckboxText,
  CheckboxWrapper,
  Checkmark,
  HiddenCheckbox,
  StyledCheckbox
} from "./styled";

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (x: any) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, checked, onChange }) => {
  return (
    <CheckboxWrapper>
      <HiddenCheckbox checked={checked} onChange={onChange} />
      <StyledCheckbox checked={checked}>
        <Checkmark checked={checked}>
          <FiCheck color="#fff" />
        </Checkmark>
      </StyledCheckbox>
      <CheckboxText>{label}</CheckboxText>
    </CheckboxWrapper>
  );
};

export default Checkbox;
